import { fork, put, takeLatest } from "redux-saga/effects";

import ApiClient from "../../../api/ApiClient";
import { fetchOffersRoutine } from "./index";
import { injectGuaranteedUserOffer } from "./utils/injectGuaranteedUserOffer";
import sortPlansByOrder from "./utils/sortPlansByOrder";

function* fetchOffers() {
  try {
    yield put(fetchOffersRoutine.request());

    const { data } = yield ApiClient.get({
      urlPath: "app.plans.offers"
    });

    if (data) {
      let guaranteedUserOffer;

      try {
        const { data: guaranteedUserOfferData } = yield ApiClient.get({
          urlPath: "app.payment.userOffer",
          skipAccessCheck: true
        });

        if (!!guaranteedUserOfferData) {
          guaranteedUserOffer = guaranteedUserOfferData;
          injectGuaranteedUserOffer({ offersRef: data, guaranteedUserOffer });
        }
      } catch (e) {
      }

      sortPlansByOrder({ offersRef: data });

      yield put(
        fetchOffersRoutine.success({ offers: data, guaranteedUserOffer })
      );
    } else {
      yield put(fetchOffersRoutine.failure());
    }
  } catch (e) {
    yield put(fetchOffersRoutine.failure(e));
  }
}

function* watchPlans() {
  yield takeLatest(fetchOffersRoutine.TRIGGER, fetchOffers);
}

export default [fork(watchPlans)];
